import type { InstalledPresetManifest } from '@cli-types/preset-engine/presets.js'
import { createInstallableManifestStore } from '@core-engine/installable/manifest-store.js'

export const presetManifestStore =
  createInstallableManifestStore<InstalledPresetManifest>('presets')
